import React, {ErrorInfo, ReactNode} from "react";
import {sendErrorEvent} from '../events/EventsService';

interface ErrorHandlerProps {
    metricsService: any;
    children: ReactNode;
}

interface State {
    hasError: boolean,
}

class ErrorHandler extends React.Component<ErrorHandlerProps, State> {

    constructor(props: ErrorHandlerProps) {
        super(props);
        this.state = {
            hasError: false
        }
    }

    static getDerivedStateFromError(error: Error) {
        return {hasError: true};
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        this.sendError(error, info);
    }

    sendError(error: Error, info: ErrorInfo): void {
        console.error(error, info);
        const errorContent = `${error.name}\n${error.message}.\n${error.stack}`;
        sendErrorEvent(errorContent);
        this.props.metricsService.setLogsBuffer(errorContent);
        this.props.metricsService.renderError();
    }

    render() {
        if (this.state.hasError) {
            return <div></div>
        } else {
            return this.props.children;
        }
    }
}

export default ErrorHandler;
